export const siteInfo = {
  name: '出轨同学会',
  originalName: '불륜 동창회',
  englishName: 'Adultery Alumni Association',
  tagline: '一场同学会，几段藏不住的旧情与心事',
  summary:
    '《出轨同学会》是韩国出品的剧情 / 爱情类系列电影，围绕一场又一场同学聚会展开，讲述成年人在婚姻倦怠、旧日情愫与信任危机之间的选择。本站把故事梗概、分部（分集）剧情、人物关系与结局解析集中整理在一页，帮你从开头到结局一次看懂。',
  facts: [
    { label: '作品类型', value: '剧情 / 爱情', icon: 'ri-film-line' },
    { label: '出品地区', value: '韩国 · 韩语', icon: 'ri-global-line' },
    { label: '作品形态', value: '系列电影（分部）', icon: 'ri-stack-line' },
    { label: '首部时间', value: '2018 年 3 月', icon: 'ri-calendar-line' },
    { label: '后续系列', value: '2019 / 2020 年', icon: 'ri-history-line' },
    { label: '主要场景', value: '同学聚会 · 密闭空间', icon: 'ri-home-4-line' },
  ],
  notice:
    '说明：本作品为独立系列电影，并非连续剧，因此本文的“分集剧情”按“分部 / 回目”的方式梳理，便于对照观看。页面内容为剧情整理与观感解析，仅供参考，具体情节以正片为准。',
};

export const quickNav = [
  { id: 'overview', label: '作品概览' },
  { id: 'synopsis', label: '故事梗概' },
  { id: 'characters', label: '人物角色' },
  { id: 'episodes', label: '分集剧情' },
  { id: 'timeline', label: '剧情脉络' },
  { id: 'ending', label: '结局解析' },
  { id: 'themes', label: '主题看点' },
  { id: 'faq', label: '观剧问答' },
];